import React from "react";
import butterflyImg from "../../assets/thyroid-icon.png";

export const ThyroidIcon = ({ className = "w-6 h-6", style }) => (
  <img
    src={butterflyImg}
    alt="Kilpnäärme Kliinik"
    className={className}
    style={{ objectFit: "contain", ...style }}
  />
);

export default ThyroidIcon;
